"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _lodash = _interopRequireDefault(require("lodash"));

var _fieldDefinitionTypes = require("../fields/config/fieldDefinitionTypes");

var _types = require("../types");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var OptionDefinition = _flowRuntime["default"].tdz(function () {
  return _types.OptionDefinition;
});

var SelectDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.SelectDefinition;
});

// eslint-disable-next-line import/no-anonymous-default-export
var _default = function _default(selectConfig, defaultItems, items) {
  var totalItems = [].concat((0, _toConsumableArray2["default"])(items), (0, _toConsumableArray2["default"])(defaultItems)); // $FlowFixMe WEB-352

  var uniqueItems = _lodash["default"].uniqBy(totalItems, 'key');

  return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
    key: selectConfig.key
  }, selectConfig), {}, {
    items: uniqueItems
  });
};

exports["default"] = _default;